import theme from '../../Theme';
import React from 'react';
import { Button } from '../../elements';
const bordedSize = 55;
const borderPadding = 5;
export const textBorded = {
    /*flex: 1,*/
    height: bordedSize,
    width: bordedSize,
    borderColor: theme.color.primary,
    borderWidth: 2,
    borderRadius: 5,
    fontWeight: '300',
    fontSize: 30,
    lineHeight: bordedSize - borderPadding
};
export const KeyTouchable = (props) => {
    return (React.createElement(Button, Object.assign({ style: {
            padding: 0,
            height: 70,
            width: 70,
            justifyContent: 'center',
            alignItems: 'center'
        } }, props), props.children));
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/components/KeyTouchable.tsx
// module id = 241
// module chunks = 0